/* Copyright (c) 2026 Health Endeavors, LLC. All Rights Reserved */

import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

export const SearchIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.0827 17.196L23.6093 21.724C24.1307 22.2453 24.1307 23.088 23.6093 23.6093C23.3493 23.8693 23.008 24 22.6667 24C22.3253 24 21.984 23.8693 21.724 23.6093L17.196 19.0827C15.3907 20.4867 13.128 21.3333 10.6667 21.3333C4.78533 21.3333 0 16.548 0 10.6667C0 4.78533 4.78533 0 10.6667 0C16.548 0 21.3333 4.78533 21.3333 10.6667C21.3333 13.128 20.4867 15.3907 19.0827 17.196ZM10.6667 2.66667C6.25467 2.66667 2.66667 6.25467 2.66667 10.6667C2.66667 15.0787 6.25467 18.6667 10.6667 18.6667C15.0787 18.6667 18.6667 15.0787 18.6667 10.6667C18.6667 6.25467 15.0787 2.66667 10.6667 2.66667Z"
        fill="inherit"
      />
    </SvgIcon>
  );
};
